<template>
  <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search"
    :onFinish='pageSearchChange' layout='inline'>
    <a-form-item label="关键字" name='product_name'>
      <a-input v-model:value="search.product_name" :style="{width:'300px'}" placeholder="请输入关键词进行搜索" />
    </a-form-item>
    <!-- <a-form-item label="商品分类" name='type_id'>
      <a-select v-model:value="search.type_id" :style="{width:'140px'}" placeholder="全部">
        <a-select-option value="">全部</a-select-option>
        <a-select-option value="shanghai">正常</a-select-option>
        <a-select-option value="beijing">禁用</a-select-option>
      </a-select>
    </a-form-item> -->
    <a-form-item>
      <a-button type="primary" htmlType='submit'>搜索</a-button>
    </a-form-item>
  </a-form>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
    <template v-slot:info="{record}">
      <a-card-meta>
        <template #avatar>
          <img :src="info.picdomain+'/'+(record.product_image||record.cover_image_url)" alt=""
            style="width:50px;height: 50px;object-fit:cover">
        </template>
        <template #description>{{record.product_name}}</template>
      </a-card-meta>
    </template>
    <template v-slot:action="{ record }">
      <a-button type="primary" @click='select(record)'>{{!record.select ?
        "选择":"已选择"}}</a-button>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
    :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" />
  <div class="s_flex_center m-t-25" v-if='checkout'>
    <a-button type="primary" @click='confirm'>确定</a-button>
  </div>
</template>

<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { antisFakeTem} from "@/api/qrcode";
  import { message } from "ant-design-vue";
  import { getProduct } from "@/api/product";
  import { iscode } from "@/utils/app";
  import store from "@/store";
  // 初始化默认筛选项数值
  let defSearch = {
    verify_status: "2",
    page: 1,
    limit: 5
  };
  export default {
    name: "fwAudiSelect",
    components: {},
    props: {
      selectLimit:{
        type:Number
      }
    },
    setup(props, { emit }) {
      // // 初始化 分页信息和筛选项信息
      let search = ref({ ...defSearch });
      // 列表数据和列头配置
      let data = ref([]);
      const state = reactive({
        info: store.state.user.info,
        listLoading: false,
        total: 1,
        selectList: [],
        checkout: false,
      });
 let columns = [
      {
        title: "认证ID",
        dataIndex: "id",
        key: "id",
      },
      {
        title: "认证名称",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "备注",
        dataIndex: "remarks",
        key: "remarks",
      },
      {
        title: "创建时间",
        dataIndex: "create_time",
        key: "create_time",
      },
      {
        title: "操作",
        dataIndex: "action",
        key: "action",
        slots: { customRender: "action" },
      },
    ];
      const $router = inject('$router')
      const $Modal = inject('$Modal')
      const _lodash = inject("_lodash");

      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      //单选
      const select = (e) => {
        data.value.map(item => item.select = false)
        e.select = !e.select
        emit("select", e);
      }
      const initData = async (values) => {
        state.listLoading = true;
        try {
          let res = await antisFakeTem(search.value).then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data;
            state.total = res.meta.total;
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };
      onMounted(() => {
        initData(search.value);
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        select,
        confirm
      };
    },
  };
</script>